import axios from "axios";
import { Token } from "../utils/localStorage.util";
import config from "../config.js";

const apiFinanceiro = axios.create({
  baseURL: config.REACT_APP_HOST_API_FINANCEIRO,
});

apiFinanceiro.interceptors.request.use(
  async (config) => {
    const token = Token.getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

apiFinanceiro.interceptors.response.use(
  (response) => {
    return response.data;
  },

  async function (error) {
    if (error?.code === "ERR_NETWORK") {
      console.error("Erro de conexão (ERR_NETWORK):", error);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export function buscarCondicoesComerciais(idGrupoEconomico, limit, paginacao) {
  return apiFinanceiro.get(
    `/condicao-comercial/grupo-economico/${idGrupoEconomico}`
  );
}
export function buscarCondicoesComerciaisPorTexto(idGrupoEconomico, texto) {
  if (idGrupoEconomico) {
    return apiFinanceiro.get(
      `/condicao-comercial/buscar-por-campos?textoDeBusca=${encodeURIComponent(
        texto
      )}&idGrupo=${encodeURIComponent(idGrupoEconomico)}`
    );
  } else {
    return apiFinanceiro.get(
      `/condicao-comercial/buscar-por-campos?textoDeBusca=${encodeURIComponent(
        texto
      )}`
    );
  }
}
export function cadastrarCondicaoComercial(condicaoComercial) {
  return apiFinanceiro.post(`/condicao-comercial/`, condicaoComercial);
}
export function excluirCondicaoComercial(idCondicaoComercial) {
  return apiFinanceiro.delete(`/condicao-comercial/${idCondicaoComercial}`);
}
export function atualizarCondicaoComercial(
  condicaoComercial,
  idCondicaoComercial
) {
  return apiFinanceiro.put(
    `/condicao-comercial/${idCondicaoComercial}`,
    condicaoComercial
  );
}

//  Valores de Fatura
export function buscarValoresFatura(idEmpresa, limit, paginacao) {
  let url = `/valores-fatura/${idEmpresa}`;
  return apiFinanceiro.get(url);
}

//  Obter valores de fatura por campos
export function buscarValoresFaturasPorCampo(
  idEmpresa,
  textodebusca,
  limit,
  paginacao
) {
  return apiFinanceiro.get(
    `/valores-fatura/${idEmpresa}/buscar-por-campos?textoDeBusca=${encodeURIComponent(
      textodebusca
    )}`
  );
}

//  Cadastrar valor de fatura
export function cadastrarValorFatura(idEmpresa, valorFatura) {
  return apiFinanceiro.post(`/valores-fatura/${idEmpresa}`, valorFatura);
}

export function atualizarValoresFatura(
  idEmpresa,
  idFinanceiroValorFatura,
  valorFatura
) {
  return apiFinanceiro.put(
    `/valores-fatura/${idEmpresa}/valor/${idFinanceiroValorFatura}`,
    valorFatura
  );
}

export function excluirValoresFatura(idEmpresa, idFinanceiroValorFatura) {
  return apiFinanceiro.delete(
    `/valores-fatura/${idEmpresa}/valor/${idFinanceiroValorFatura}`
  );
}

export function buscarFaturamentosPorGrupoEconomico(idGrupoEconomico) {
  return apiFinanceiro.get(`/faturamento/${idGrupoEconomico}`);
}

export function obterFaturasPorCampo(textoDeBusca, idGrupoEconomico) {
  if (!idGrupoEconomico) {
    return apiFinanceiro.get(
      `/faturamento/buscar-por-campos?textoDeBusca=${encodeURIComponent(
        textoDeBusca
      )}`
    );
  } else {
    return apiFinanceiro.get(
      `/faturamento/buscar-por-campos?textoDeBusca=${encodeURIComponent(
        textoDeBusca
      )}&idGrupoEconomico=${encodeURIComponent(idGrupoEconomico)}`
    );
  }
}
export default apiFinanceiro;
